<style scoped>
@import url(../assets/css/bootstrap.min.css);
.screen {
  background: url('../assets/img/vignette_gradient.png'), url('../assets/img/Background_Download.jpg');
  background-position: center center, 20% 0;
  background-size: cover, cover;
  background-repeat: repeat, no-repeat;
}

</style>

<template>
  <div>
    <div class v-if="member && member.subscription_data && subscription">
      <!-- <pre class="">{{subscription.summary}}</pre> -->
<img src="../assets/img/Web_Download_blurb.png" />
 <a
                  class="d-block"
                  href="https://itunes.apple.com/us/app/studio-1-treadmill-app/id1243064148?mt=8"
                >
                  <img style="width:150px;" src="../assets/img/Button_Download_On_App_Store.png" />
                </a>

      <!-- <nav class="navbar sticky-top navbar-light bg-light">
        <a class="navbar-brand" href="#">
          <img
            class="rounded-circle border shadow shadow-sm"
            style="width:30px;"
            @dblclick="logout()"
            :src="member.avatar_url"
          />
        </a>
        {{member.email}}
      </nav> -->

      <div class="row">
        <div class="col-12">
          <ul class="list-group mt-3 text-left ml-3 mr-3">
            <!--
      TRIAL ENDED
      MEMBERSHIP ACTIVE
            -->
            <li class="list-group-item list-group-item-info">
              <div v-if="subscription">
                <i
                  v-bind:class="{'fab fa-2x fa-apple' : subscription.summary.gateway == 'apple', 'fab fa-cc-stripe' : subscription.summary.gateway  == 'stripe'}"
                  class="fab fa-1x fa-apple"
                ></i>
                <strong class="text-capitalize">
                  Studio Membership
                  <span class="badge badge-info">{{subscription.summary.type}} Plan</span>
                  <span v-if="subscription.summary.trial.active" class="badge badge-success">Trial</span>
                </strong>

                <p class="text-muted mt-2 mb-0 small">
                  <span v-if="subscription.summary.trial.active">
                    Your Trial started {{subscription.summary.purchased.fromNow}} and ends {{subscription.summary.expires.formatted}}
                    ({{subscription.summary.expires.fromNow}})
                  </span>

                  <span v-if="!subscription.summary.trial.active">
                    Membership started {{subscription.summary.purchased.fromNow}} and ends {{subscription.summary.expires.formatted}}
                    ({{subscription.summary.expires.fromNow}})
                  </span>
                </p>

                <!-- <pre class="text-left bg-dark text-light p-2">
                           {{subscription.summary}}

                </pre>-->
              </div>
            </li>

            <li class="list-group-item">
              <strong>Community Username</strong>
              {{member.username}}
            </li>
            <li class="list-group-item">
              <strong>Login Email</strong>
              {{member.email}}
            </li>
            <li class="list-group-item" @dblclick="logout()">
              <strong>Member Id</strong>
              {{member.id}}
            </li>
            <li class="list-group-item" v-if="subscription && subscription.summary">
              <strong>Account Created</strong>
              {{subscription.summary.created.fromNow}}
              <small
                class="text-muted d-block"
              >{{subscription.summary.created.long}}</small>
            </li>

            <ul class="list-group" v-if="subscription && subscription.summary">
              <li class="list-group-item" v-if="subscription.summary.trial.active">
                <strong class="text-capitalize">{{subscription.summary.type}} Trial Ends</strong>
                {{subscription.summary.expires.fromNow}}
                <small
                  class="text-muted d-block"
                >{{subscription.summary.expires.long}}</small>
                <!-- <pre>{{subscription.summary.expires}}</pre> -->
                <!-- <a
                  class="float-right"
                  href="https://itunes.apple.com/us/app/studio-1-treadmill-app/id1243064148?mt=8"
                >
                  <img style="width:150px;" src="../assets/img/Button_Download_On_App_Store.png" />
                </a> -->
              </li>

              <li class="list-group-item" v-if="!subscription.summary.trial.active">
                <strong>Membership Started</strong>
                {{subscription.summary.created.fromNow}}
                <small
                  class="text-muted d-block"
                >{{subscription.summary.created.long}}</small>
                <small
                  class="text-muted d-block"
                >renews on {{subscription.summary.expires.calendar}}</small>
                <!-- <pre>{{subscription}}</pre> -->
              </li>

              <!-- <li class="list-group-item"><pre>{{summary}}</pre></li> -->
            </ul>

            <!-- <li class="list-group-item"><pre>{{summary}}</pre></li> -->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
export default {
  name: 'Account',
  props: ['api-base', 'member', 'stripe-plans', 'subscription'],
  data () {
    return {
      self: this
    }
  },
  methods: {
    done (type) {
      this.$emit('done')
    },
    logout () {
      this.$emit('loading', true)
      setTimeout(
        function () {
          this.$emit('logout')
        }.bind(this),
        800
      )
    }
  },
  created () {
    // this.subscriptionDetails()
  },
  beforeDestroy () {}
}
</script>



// WEBPACK FOOTER //
// src/components/Account.vue